var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatuspending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/timer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1442 9.64083L7.78753 7.5H6.20669L3.85003 9.64083C3.19086 10.2358 2.97503 11.1517 3.29586 11.98C3.61669 12.8025 4.39836 13.3333 5.27919 13.3333H8.71503C9.60169 13.3333 10.3775 12.8025 10.6984 11.98C11.0192 11.1517 10.8034 10.2358 10.1442 9.64083ZM8.06169 11.0817H5.93836C5.71669 11.0817 5.54169 10.9008 5.54169 10.685C5.54169 10.4692 5.72253 10.2883 5.93836 10.2883H8.06169C8.28336 10.2883 8.45836 10.4692 8.45836 10.685C8.45836 10.9008 8.27753 11.0817 8.06169 11.0817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.7042 3.02001C10.3834 2.19751 9.60172 1.66667 8.72089 1.66667H5.27922C4.39839 1.66667 3.61672 2.19751 3.29589 3.02001C2.98089 3.84834 3.19672 4.76417 3.85589 5.35917L6.21255 7.50001H7.79339L10.1501 5.35917C10.8034 4.76417 11.0192 3.84834 10.7042 3.02001ZM8.06172 4.71751H5.93839C5.71672 4.71751 5.54172 4.53667 5.54172 4.32084C5.54172 4.10501 5.72255 3.92417 5.93839 3.92417H8.06172C8.28339 3.92417 8.45839 4.10501 8.45839 4.32084C8.45839 4.53667 8.27755 4.71751 8.06172 4.71751Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatuspending);
export default __webpack_public_path__ + "static/media/statuspending.a08efc180a1a8ad2dcf7c19e211f6d4d.svg";
export { ForwardRef as ReactComponent };